var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("w-fit py-[6px] px-[10px] rounded-full border-[1px] text-[12px] font-medium rounded-full px-[4px] py-[2px] border-[1px] mb-0 " + _vm.activeClass)},[_vm._v(" "+_vm._s(_vm.statusPillConfig.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }